







import { Component, Vue } from 'vue-property-decorator'
import { Message, MessageBox } from 'element-ui'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryCouponUserCouponList, VoidUserCoupon, ExportCouponUserCouponList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'

const STATUS_MAP: Record<number, string> = {
  0: '未使用',
  1: '锁定',
  2: '已使用',
  3: '已过期',
  4: '已作废',
}

@Component({ components: { VQuery, VTable } })
export default class CouponUserCouponList extends Vue {
  private queryParam: any = { startRow: 1, limit: 10, createTimeDaterange: [] }
  private tableTotal = 0
  private tableData: any[] = []
  private tableCurrntPage = 1

  private queryModels: Array<QueryModel> = [
    { title: '用户ID', param: 'userId' },
    { title: '模板ID', param: 'couponTemplateId' },
    {
      title: '状态',
      param: 'status',
      type: 'select',
      selectData: [
        { label: '未使用', value: 0 },
        { label: '锁定', value: 1 },
        { label: '已使用', value: 2 },
        { label: '已过期', value: 3 },
        { label: '已作废', value: 4 },
      ],
    },
    { title: '订单号', param: 'orderCode' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
  ]

  private queryOperation: Array<TableOperation> = [
    { title: '导出', type: 'warning', click: this.exportHandle },
  ]

  private tableHander: Array<TableHander> = [
    { title: 'ID', param: 'id', width: 70 },
    { title: '用户ID', param: 'userId', width: 90 },
    { title: '昵称', param: 'userNickname', width: 100 },
    { title: '手机号', param: 'mobilePhone', width: 120 },
    { title: '模板', param: 'templateName', minWidth: 120 },
    { title: '状态', param: 'status', width: 80, formatter: (v: number) => STATUS_MAP[v] || String(v) },
    { title: '订单号', param: 'orderCode', width: 180, overflow: true },
    { title: '生效', param: 'validStartTime', width: 150, formatter: DateFormat },
    { title: '失效', param: 'validEndTime', width: 150, formatter: DateFormat },
    { title: '使用时间', param: 'useTime', width: 150, formatter: DateFormat },
    { title: '来源', param: 'grantSource', width: 110 },
    {
      title: '操作',
      width: 90,
      operation: [
        {
          title: '作废',
          show: (row: any) => row.status === 0 || row.status === 1 || row.status === 3,
          click: (row: any) => this.onVoid(row),
        },
      ],
    },
  ]

  activated() {
    this.loadData()
  }

  created() {
    this.loadData()
  }

  private async loadData() {
    const result = await QueryCouponUserCouponList(this.getRequestParam())
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam() {
    const param = this.buildExportParam()
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 10)
    return param
  }

  private buildExportParam() {
    const param: any = { ...this.queryParam }
    if (param.createTimeDaterange && param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    delete param.createTimeDaterange
    delete param.startRow
    delete param.limit
    return param
  }

  private async onVoid(row: any) {
    try {
      await MessageBox.confirm(`确认作废用户券 #${row.id}？`, '提示', { type: 'warning' })
      await VoidUserCoupon({ userCouponId: row.id })
      Message.success('已作废')
      this.loadData()
    } catch (e) {
      // cancel
    }
  }

  search() {
    this.tableCurrntPage = 1
    this.loadData()
  }

  pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private exportHandle() {
    const loading = this.$loading({
      lock: true,
      text: '正在导出',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    })
    const param = this.buildExportParam()
    ExportCouponUserCouponList(param, '用户优惠券.xlsx')
      .then(() => loading.close())
      .catch(() => loading.close())
  }
}
